/** The note shown instead of forms whose writes need the `admin` scope (the server answers 403 to anyone else). */
export function AdminOnlyNote({ what, testId }: { what: string; testId: string }) {
  return (
    <p className="ws7-muted" data-testid={testId} data-admin-only="true">
      Admin only: {what}. You can read this tab; ask an admin to change it.
    </p>
  );
}
